var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 347.857,
    height: 217.176,
    viewBox: "0 0 347.857 217.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{fill:#2f2e41;}.c,.i,.j{fill:#ee5050;}.d{fill:#a8a8a8;}.e{opacity:0.2;}.f{fill:#3f3d56;}.g{opacity:0.1;}.h{fill:none;stroke:#2f2e41;stroke-miterlimit:10;stroke-width:2px;}.i{opacity:0.4;}.j{opacity:0.8;}.k{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 66.178,
    cy: 66.178,
    r: 66.178,
    transform: "translate(24.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.391,151.642c0,24.078,15.105,43.562,33.773,43.562",
    transform: "translate(-31.391 -135.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M140.092,194.119c0-24.349,16.857-44.052,37.689-44.052",
    transform: "translate(-106.319 -134.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.775,158.668c0,22.872,9.632,41.379,21.536,41.379",
    transform: "translate(-58.539 -140.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M140.092,166.971c0-31.112,19.484-56.288,43.562-56.288",
    transform: "translate(-106.319 -107.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M117.224,287.1s4.79-.148,6.233-1.175,7.368-2.255,7.726-.607,7.2,8.2,1.79,8.242-12.564-.842-14-1.72S117.224,287.1,117.224,287.1Z",
    transform: "translate(-90.556 -227.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M133.069,298.712c-5.407.044-12.564-.842-14-1.72-1.1-.668-1.534-3.066-1.681-4.173l-.16.006s.3,3.863,1.744,4.74,8.6,1.763,14,1.72c1.561-.013,2.1-.568,2.07-1.39C134.826,298.392,134.231,298.7,133.069,298.712Z",
    transform: "translate(-90.556 -233.067)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 58.1,
    cy: 7.904,
    rx: 58.1,
    ry: 7.904,
    transform: "translate(3.607 123.986)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 48.779,
    cy: 6.636,
    rx: 48.779,
    ry: 6.636,
    transform: "translate(12.928 125.254)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 87.927,
    cy: 11.962,
    rx: 87.927,
    ry: 11.962,
    transform: "translate(172.004 193.252)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 52.818,
    cy: 7.186,
    rx: 52.818,
    ry: 7.186,
    transform: "translate(43.687 193.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M494,664.463c27.963,7.146,81.713-9.321,87.616-27.963",
    transform: "translate(-350.27 -469.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M341,355.86s40.39-11.185,42.876,24.856-33.244,46.294-5.282,53.44",
    transform: "translate(-244.806 -275.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M215.4,636.689s12.14-3.362,12.887,7.471-9.992,13.914-1.587,16.062",
    transform: "translate(-158.231 -469.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M790.032,661.651l-2.448,15.626s-12.049,6.4-3.577,6.589,48.385,0,48.385,0,7.719,0-4.518-6.778l-2.448-16.38Z",
    transform: "translate(-548.092 -486.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M782.308,683.7a33.33,33.33,0,0,1,5.281-3.5l2.448-15.626,35.4.033,2.448,15.4a32.143,32.143,0,0,1,5.656,3.722c1.572-.359,3.289-1.691-5.656-6.645l-2.448-16.38-35.4.941-2.448,15.626S777.465,682.657,782.308,683.7Z",
    transform: "translate(-548.097 -486.656)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 159.465,
    height: 111.08,
    rx: 18.046,
    transform: "translate(179.716 66.081)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 148.734,
    height: 83.216,
    transform: "translate(185.082 72.012)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.941,
    cy: 0.941,
    r: 0.941,
    transform: "translate(258.508 68.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M769.29,621.322v9.738a5.606,5.606,0,0,1-5.607,5.607H615.431a5.606,5.606,0,0,1-5.607-5.608v-9.737Z",
    transform: "translate(-430.108 -459.505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M744.258,652.429v1.883H642.968v-1.506l.14-.377,2.5-6.778h96.583Z",
    transform: "translate(-443.201 -445.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1062.741,747.652c-.185.789-.881,1.621-2.455,2.408-5.648,2.824-17.133-.753-17.133-.753s-8.849-1.506-8.849-5.46a7.073,7.073,0,0,1,.776-.461c2.375-1.256,10.248-4.356,24.209.131a5.822,5.822,0,0,1,2.654,1.739A2.776,2.776,0,0,1,1062.741,747.652Z",
    transform: "translate(-722.705 -542.116)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1064.462,747.652c-6.913,2.649-13.075,2.847-19.4-1.546a13.888,13.888,0,0,0-8.261-2.721c2.375-1.256,10.248-4.356,24.209.131a5.822,5.822,0,0,1,2.654,1.739A2.776,2.776,0,0,1,1064.462,747.652Z",
    transform: "translate(-724.425 -542.116)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.448,
    cy: 0.753,
    rx: 2.448,
    ry: 0.753,
    transform: "translate(328.921 202.483)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.577,
    cy: 3.577,
    r: 3.577,
    transform: "translate(255.872 165.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M744.258,667.466v1.883H642.968v-1.506l.14-.376Z",
    transform: "translate(-443.201 -460.088)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 64.625,
    height: 75.188,
    transform: "translate(33.744 49.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 77.674,
    height: 26.72,
    transform: "translate(27.22 41.944)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 77.674,
    height: 26.72,
    transform: "translate(27.22 73.635)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 77.674,
    height: 26.72,
    transform: "translate(27.22 105.326)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 4.971,
    height: 4.971,
    transform: "translate(84.388 46.604)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 4.971,
    height: 4.971,
    transform: "translate(91.534 46.604)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.971,
    height: 4.971,
    transform: "translate(98.68 46.604)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 4.971,
    height: 4.971,
    transform: "translate(84.388 77.984)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 4.971,
    height: 4.971,
    transform: "translate(91.534 77.984)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.971,
    height: 4.971,
    transform: "translate(98.68 77.984)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 4.971,
    height: 4.971,
    transform: "translate(84.388 109.365)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 4.971,
    height: 4.971,
    transform: "translate(91.534 109.365)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.971,
    height: 4.971,
    transform: "translate(98.68 109.365)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 24.545,
    cy: 24.545,
    r: 24.545,
    transform: "translate(73.824 142.609)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7.457,
    height: 13.36,
    transform: "translate(87.184 186.417)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7.457,
    height: 13.36,
    transform: "translate(102.097 186.417)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 6.214,
    cy: 2.33,
    rx: 6.214,
    ry: 2.33,
    transform: "translate(87.184 197.602)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 6.214,
    cy: 2.33,
    rx: 6.214,
    ry: 2.33,
    transform: "translate(102.097 197.291)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 8.389,
    cy: 8.389,
    r: 8.389,
    transform: "translate(90.601 152.551)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 2.796,
    cy: 2.796,
    r: 2.796,
    transform: "translate(96.194 158.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M270.562,519.514c-1.982-8.876,4.353-17.844,14.15-20.032s19.345,3.234,21.327,12.11-4.511,12.149-14.308,14.337S272.544,528.39,270.562,519.514Z",
    transform: "translate(-196.003 -375.186)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 12.272,
    cy: 3.853,
    rx: 12.272,
    ry: 3.853,
    transform: "translate(107.075 160.003) rotate(-23.171)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 12.272,
    cy: 3.853,
    rx: 12.272,
    ry: 3.853,
    transform: "translate(61.092 176.47) rotate(-23.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M335.409,657.731c0,2.4-6.185,7.146-13.049,7.146S309,660.444,309,658.041s6.5-1.864,13.36-1.864S335.409,655.328,335.409,657.731Z",
    transform: "translate(-222.748 -483.431)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.27209e69a6bb0ec9a6d3aaf3e6a5c2ec.svg";
export { ForwardRef as ReactComponent };